export default __webpack_public_path__ + "static/media/0_2.53fc99ab.png";